import { Icon } from '@/icons'
import React, { FunctionComponent } from 'react'

import styles from './NavigationBack.module.scss'
import cn from 'classnames'

type NavigationBackProps = {
  title: string
  onClick?: () => void
  className?: string
}

export const NavigationBack: FunctionComponent<NavigationBackProps> = ({
  title,
  onClick,
  className,
}) => {
  return (
    <button onClick={onClick} className={cn(styles.back, className)}>
      <Icon name="chevron" className={styles.backIcon} />
      <span className={styles.backText}>{title}</span>
    </button>
  )
}
